import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import * as DateFns from 'date-fns';
import { LIVE_PRACTICE, REFRESH_INTERVALS} from '../../../config/constants';
import { useInterval } from '../../../helpers/customHooks';
import { useDataEventsState } from '../../../store/hooks';
import { useManageDispatch } from 'store/hooks/manage';
import { customEventsType, Manage } from 'config/commonTypes';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';
import { message } from 'antd';
import { Row, Col, Form } from 'react-bootstrap';
import EventLoggerHeader from './EventLoggerHeader';
import { useCustomEventsDispatch, useCustomEventsState } from 'store/hooks/customEvents';
import { text_truncate } from 'helpers';
type updateQueueProps ={
  queue: any[];
  fetching: number;
}

const EventLoggerMobile = () => {
    const { dataEvent, data:dataManage, meta } = useDataEventsState();
    const teamId = meta.homeTeam.teamId;
    const practice = dataManage.manage;
    const eventId = meta._id;
    const league = meta.league;
    const{ customEvents } = useCustomEventsState();
    const { updateCustomEvents, loadCustomEvents } = useCustomEventsDispatch();
    const {updatePractice, getPractice} = useManageDispatch();
    const { changePracticeSavedSuccessfullyFlag } = useFlagsDispatch();
    const { practiceSaved } = useFlagsState();
    const hidePracticeSavedMessage = () => {
      changePracticeSavedSuccessfullyFlag(false);
    };
    useEffect(() => {
      loadCustomEvents(teamId,true);
    }, []);
    const customEventsButtons:customEventsType = customEvents&& customEvents[teamId];
    const [editCustomEvt, setEditCustomEvt]=useState(false);
    const [customEventOne, setCustomEventOne] = useState('');
    const [customEventTwo, setCustomEventTwo] = useState('');
    const [customEventThree, setCustomEventThree] = useState('');
    const [practiceCopy, setPracticeCopy] = useState(JSON.parse(JSON.stringify(practice)));

    const handleCustomEventChange = (event:any, index:number) => {
      if(index === 0){
        setCustomEventOne(event.target.value);
      }else if(index > 0 && index < 2){
        setCustomEventTwo(event.target.value);
      }else{
        setCustomEventThree(event.target.value);
      }
      
  };

  const handleEditSwithc = ()=>{
    if(!editCustomEvt){
      setEditCustomEvt(true);
      setCustomEventOne(customButtonOne);
      setCustomEventTwo(customButtonTwo);
      setCustomEventThree(customButtonThree);
    }else{
      setEditCustomEvt(false);
      resetCustomEvents();
    }
  };
  const resetCustomEvents = () =>{
    setCustomEventOne(customButtonOne);
    setCustomEventTwo(customButtonTwo);
    setCustomEventThree(customButtonThree);
    
  };
    const currentDrillIndex = practice && practice.currentDrillIndex ? practice.currentDrillIndex : 0;
    const [isInProgressPeriod, setIsInProgressPeriod] = useState(false);
    const [editable, setEditable] = useState(false);
    const [ended, setEnded] = useState(false);
    const timer = useRef<null | NodeJS.Timeout>(null);
    const [updateQueue, setUpdateQueue] = useState<updateQueueProps>({ queue: [], fetching: 0 });
    const newPractice = (practice:Manage) => {
        const newPractice = JSON.parse(JSON.stringify(practice));
        if (newPractice.drills) {
          for (let i = 0; i < newPractice.drills.length; ++i) {
            newPractice.drills[i]['drillId'] = i;
          }
        }
        return newPractice;
      };
      const [currentPractice, setCurrentPractice] = useState<Manage>(newPractice(practice));
      useEffect(() => {
        setCurrentPractice(newPractice(practice));
        
      }, [practice]);
    
      useInterval(() => {
          getPractice(eventId, league!, true);
          loadCustomEvents(teamId, true);
      }, REFRESH_INTERVALS.MANAGE);
      
      const customButtonOne = customEventsButtons? customEventsButtons.find((number)=> number.num === 1)?.name || '-':'-';
      const customButtonTwo = customEventsButtons?  customEventsButtons.find((number)=> number.num === 2)?.name || '-':'-';
      const customButtonThree = customEventsButtons? customEventsButtons.find((number)=> number.num === 3)?.name || '-':'-';
      const dataButtonsRight = [
          { class: 'bb-ss', label: 'Snap' },
          { class: 'bb-ss', label: 'Throw' },
          { class: 'bb-ss', label: 'Rep' }
        ];
      const customButtons = [
          {class: 'bb-ss', label: customButtonOne },
          {class: 'bb-ss', label: customButtonTwo},
          {class: 'bb-ss', label: customButtonThree}
        ];
   

      const [checked, setChecked] = useState({
          Snap: 0,
          Throw: 0,
          Rep: 0,
        });
      let isInProgress = false;
      if (currentPractice.drills) {
        currentPractice.drills.map((drill, index) => {
            //@ts-ignore
            isInProgress |= ((DateFns.isToday(currentPractice.start) || DateFns.isPast(currentPractice.start))
              && !(index === currentDrillIndex && !currentPractice.drills[currentDrillIndex].state)
              && index === currentDrillIndex);
          });
      }
      
      const updateEventsPractice = useCallback(async (label) => {
        if (dataEvent.meta.type !== LIVE_PRACTICE) {
          return;
        }
        if (!practiceCopy.events) {
          practiceCopy.events = [];
        }
        const now = new Date().getTime();
        practiceCopy.events.push({ type: label, timeStamp: now });
        if(timer.current){
          clearTimeout(timer.current);
        }
          timer.current = setTimeout(async () => {
          await updatePractice(practiceCopy, eventId, league, meta.type, false, undefined, true);
            }, 2000);
        setChecked(prevState => ({ ...prevState, [label]: prevState[label] - 1 }));
      }, [checked, dataEvent.meta.type, eventId, league, practice, updatePractice]);
      
      if (practiceSaved) {
        // show message and then clear flags
        message.success({
          content: 'Practice Successfully Saved',
          className: 'message-pro',
          style: {
            marginTop: '60vh'
          }
        }, 10);
        hidePracticeSavedMessage();
      }

    useEffect(() => {
        setIsInProgressPeriod(isInProgress && !ended);
      });

      useEffect(() => { 
          setPracticeCopy(JSON.parse(JSON.stringify(practice)));
      },[practice]);

      const handleCustomEventSave = () =>{
        updateCustomEvents(customEventOne, customEventTwo, customEventThree, teamId, true);
        setEditCustomEvt(false);
    };
     useEffect(() => {
        if (updateQueue.queue.length && !updateQueue.fetching) {
          setUpdateQueue(prevState => ({ ...prevState, fetching: 1 }));
          updateEventsPractice(updateQueue.queue[0]).then(() => {
            setUpdateQueue(prevState => ({ queue: prevState.queue.slice(1), fetching: 0 }));
          });
        }
    }, [updateQueue]);

    const handleSaveClick = (label:string) => {
        setUpdateQueue(prevState => ({ queue: [...prevState.queue, label], fetching: prevState.fetching }));
        
        setChecked({ ...checked, [label]: checked[label] + 1 });
      };
    return(
        <> 
        <div className="new-manage">
        <EventLoggerHeader
            editable={editable}
            currentPractice={currentPractice}
            setEditable={setEditable}
            handleEditSwith={handleEditSwithc}
            handleCustomEventSave={handleCustomEventSave}
          />
        </div>
        <div className="manage-head">
          Practice Events
        </div>
        <div className="event-logger monitor" style={{ overflow: 'hidden' }}>
        <Row>
          <Col xs={6}>
        <div className="buton-ac">
        <div className="button-group">
        <div style={!isInProgressPeriod ? { opacity: '0.5', pointerEvents: 'none' } : {}}>  
        {dataButtonsRight.map((data) => (
                      <Fragment key={data.label}>
                        <input
                          id={'checkbox-' + data.label}
                          type="checkbox"
                          checked={checked[data.label]}
                          readOnly
                          onClick={() => handleSaveClick(data.label)}
                          disabled={dataEvent.meta.type !== LIVE_PRACTICE}
                        />
                        <label className={'button ' + data.class} htmlFor={'checkbox-' + data.label}>
                          <img src="/assets/icon-check.svg" height="18px" alt={data.label} />{data.label}</label>
                      </Fragment>
                    ))}   
                    </div>
                    </div>
                    </div>
                    </Col>
                    <Col xs={6}>
                     {!editable? 
                     <div className="buton-ac">
                     <div className="button-group">
                    <div style={!isInProgressPeriod ? { opacity: '0.5', pointerEvents: 'none' } : {}}> 
                    {customButtons.map((data, index) => (
                      <Fragment key={index} >
                        <input
                          style={{display: 'none'}}
                          id={'checkbox-' + data.label}
                          type="checkbox"
                          checked={checked[data.label]}
                          readOnly
                          onClick={() => handleSaveClick(data.label)}
                          disabled={dataEvent.meta.type !== LIVE_PRACTICE}
                        />
                        <label className={'button ' + data.class} htmlFor={'checkbox-' + data.label} style={data.label === '-' ? { opacity: '0.5', pointerEvents: 'none' }:{}}>
                        <img src="/assets/icon-check.svg" height="18px" alt={data.label} />{text_truncate(data.label, 10)}</label>
                      </Fragment>))}
                      </div>
                      </div>
                      </div>
                  :
                  <div className='custom-events-edit-mb'>
                  <Form>
                      {customButtons.map((data, index) => (
                       <div style={{marginBottom: '20px'}} key={index}>
                      <Form.Group as={Col} controlId="formGridEmail" key={index} >
                        <Form.Label style={{
                          fontSize: '12px',
                          color: '#007ABA',
                          fontFamily:'$condensed'}}>{`Set Custom Event ${index +1}`}</Form.Label>
                        <Form.Control type="text" placeholder={data.label} onChange={(e)=>handleCustomEventChange(e,index)} />
                      </Form.Group>
                      </div>
                        ))}
                  </Form>
                  </div>
                        }
                    </Col>
                   
         </Row>           
        </div>
        </>
    );
};
export default EventLoggerMobile;